import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Card, CardBody } from "reactstrap";

import Logo from "../common/Logo";

// services

const NotFound = () => {
	const [logo, setLogo] = useState(require("../assets/img/vda_logo.svg"));

	return (
		<>

			<Row noGutters>
				<Col xl={12}>
					<Card className="mb-3">
						<CardBody>
							<Logo location={"auth"} logo={logo} />
							<Row className="m-5">
								<Col xs="12" style={{ alignSelf: 'center', textAlign: 'center' }}>
									<h3>The proposal you are looking for is no longer available.</h3>

									<h5>Please contact us at the email below if you have any questions.</h5>
									<h5><a href='mailto:metroinspections@vdassoc.com'>metroinspections@vdassoc.com</a></h5>
								</Col>
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>

		</>
	);
};

export default NotFound;
